// extracted by mini-css-extract-plugin
export default {"input":"Input_input__SCFHN","input--disabled":"Input_input--disabled__1oV0-"};